import React from "react"
import { Button } from "react-bootstrap"
import { LanzaTable } from "../../../shared_components/widgets/LanzaTable"

import { LocaleFormattedDate } from "../../internationalization/LocaleFormatted"

export const ChangeLogButton = ({ intl, prefix, onClick, isExpanded }) => (
  <div style={{ marginLeft: "auto" }}>
    <Button variant={"outline-primary"} size={"sm"} onClick={() => onClick && onClick()}>
      <span className={`fa fa-caret-${isExpanded ? "down" : "right"}`} />
      {prefix && <>{prefix}</>}
      {intl.formatMessage({
        id: "general.change.log",
        defaultMessage: "Change Log",
      })}
    </Button>
  </div>
)

export default function ChangeLogTable({ intl, changeLogs = [] }) {
  return (
    <div
      style={{
        padding: "5px",
        backgroundColor: "var(--lanzalake-white)",
        borderRadius: "5px",
      }}
    >
      <LanzaTable
        className={"table table-bordered table-hover tbl_lanzatable"}
        columns={[
          {
            Header: <span>{intl.formatMessage({ id: "general.field", defaultMessage: "Field" })}</span>,
            accessor: "field",
          },
          ...[
            ["previous", "Previous", "old_value"],
            ["new", "New", "new_value"],
          ].map((f) => {
            return {
              Header: <span>{intl.formatMessage({ id: `general.${f[0]}`, defaultMessage: f[1] })}</span>,
              accessor: f[2],
              disableSortBy: true,
              Cell: ({ value }) => {
                if (typeof value === "string") {
                  return value.split("___").join(", ")
                } else {
                  return value
                }
              },
            }
          }),
          {
            Header: (
              <span>
                {intl.formatMessage({
                  id: "general.updated.on",
                  defaultMessage: "Updated On",
                })}
              </span>
            ),
            accessor: "updated_on",
            Cell: ({ value }) => {
              return <LocaleFormattedDate date={value} />
            },
          },
          {
            Header: (
              <span>
                {intl.formatMessage({
                  id: "general.updated.by",
                  defaultMessage: "Updated By",
                })}
              </span>
            ),
            accessor: "updated_by",
          },
        ].map((h) => {
          return { ...h, disableFilters: true }
        })}
        data={changeLogs}
        allowSorting={true}
        allowGlobalFilter={false}
        initialTableOptions={{
          sortBy: [{ id: "updated_on", desc: true }],
          pageSize: 5,
        }}
      />
    </div>
  )
}
